import { AmplitudeEvent } from "@analytics/Amplitude/AmplitudeEvents";

enum RoomChatEvent {
    TOGGLE_ROOM_CHAT = "toggle_room_chat",
    SEND_ROOM_CHAT_MESSAGE = "send_room_chat_message",
    SWITCH_CHAT_TAB = "switch_chat_tab",
    CLOSE_CHAT = "close_chat",
    SHARE_TASK_TO_CHAT = "share_task_to_chat",
}

export interface ToggleChatDetails {
    readonly source: "overlay_button" | "room_control_panel";
}

export interface ChatDetails {
    readonly chatType: "room_chat" | "ai_chat";
}

export class ToggleRoomChat extends AmplitudeEvent {
    constructor(props: ToggleChatDetails) {
        super(RoomChatEvent.TOGGLE_ROOM_CHAT);
        this.props = { ...props };
    }
}

export class SwitchChatTab extends AmplitudeEvent {
    constructor(props: ChatDetails) {
        super(RoomChatEvent.SWITCH_CHAT_TAB);
        this.props = { ...props };
    }
}

export class CloseChat extends AmplitudeEvent {
    constructor(props: ChatDetails) {
        super(RoomChatEvent.CLOSE_CHAT);
        this.props = { ...props };
    }
}

export class SendRoomChatMessage extends AmplitudeEvent {
    constructor(roomId: string, isRoomHost: boolean, fromTaskList: boolean) {
        super(RoomChatEvent.SEND_ROOM_CHAT_MESSAGE);
        this.props = { roomId: roomId, isRoomHost: isRoomHost, fromTaskList: fromTaskList };
    }
}

export class ShareTasksToChat extends AmplitudeEvent {
    constructor(roomId: string) {
        super(RoomChatEvent.SHARE_TASK_TO_CHAT);
        this.props = { roomId: roomId };
    }
}
